import React from 'react'
import Button from '../../../components/Button'
import { useHistory } from 'react-router-dom'
import styles from './JobNavigation.sass'

interface JobNavigationProps {
  next?: string
  canProceed?: boolean
  primaryAction?: React.ReactNode
  secondaryAction?: React.ReactNode
}

export default function JobNavigation({
  next,
  canProceed,
  primaryAction,
  secondaryAction,
}: JobNavigationProps) {
  const navigation = useHistory()

  return (
    <div className={styles.root}>
      <div className={styles.buttonContainer}>{secondaryAction}</div>

      <div className={styles.buttonContainer}>
        {next && (
          <Button
            onClick={() => navigation.push(next)}
            disabled={!canProceed}
            type="primary"
          >
            Next
          </Button>
        )}

        {primaryAction}
      </div>
    </div>
  )
}
